import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import PatType from "../enums/pat-type";

/**
 * Drop Kick fragment for Indoor Football.
 * Used for both PAT (2 pts) and Field Goal (4 pts) drop kicks.
 * This is a marker fragment - the kickedBy info comes from the Kick/PatKick fragment.
 */
export default class DropKick extends Fragment {
    constructor() {
        super();
        this.code = "DK";
        this.patType = PatType.DROP_KICK.code;
    }

    summarize() {
        return new FragmentSummary("drop kick");
    }

    getScoringPoints(gameConfig) {
        return gameConfig.scoring.dropKickPAT;
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
